import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer aria-label="Site footer" className="section-card border-t border-border">
      <div className="container mx-auto px-8 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img src="/logo.png" alt="Vaughan McLean" className="h-48 w-auto" />
            <p className="text-muted-foreground text-sm mt-4 font-body leading-relaxed">
              Reaching New Heights.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="text-xs tracking-[0.2em] uppercase font-body font-semibold text-foreground mb-4">
              Quick Links
            </h2>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Our Story", path: "/our-story" },
                { label: "Team", path: "/team" },
                { label: "Services", path: "/services" },
                { label: "News & Insights", path: "/news" },
                { label: "Client Intake", path: "/intake" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-muted-foreground text-sm hover:text-primary transition-colors font-body">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Careers & Contact */}
          <div>
            <h2 className="text-xs tracking-[0.2em] uppercase font-body font-semibold text-foreground mb-4">
              Careers
            </h2>
            <ul className="space-y-3">
              {[
                { label: "Join Us", path: "/join-us" },
                { label: "Locations", path: "/locations" },
              { label: "Newsletter Sign Up", path: "/newsletter" },
              { label: "Diversity", path: "/diversity" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-muted-foreground text-sm hover:text-primary transition-colors font-body">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-xs tracking-[0.2em] uppercase font-body font-semibold text-foreground mb-4">
              Contact
            </h2>
            <p className="text-muted-foreground text-sm font-body leading-relaxed">
              Two Logan Square, Suite 700<br />
              100 North 18th Street<br />
              Philadelphia, PA 19103<br />
              <a href="tel:2155692400" className="text-primary hover:opacity-80 transition-opacity">(215) 569-2400</a>
            </p>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-xs font-body">
            © {new Date().getFullYear()} Vaughan McLean. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/" className="text-muted-foreground text-xs hover:text-primary transition-colors font-body">
              Home
            </Link>
            <Link to="/privacy" className="text-muted-foreground text-xs hover:text-primary transition-colors font-body">
              Privacy Policy
            </Link>
            <Link to="/disclaimer" className="text-muted-foreground text-xs hover:text-primary transition-colors font-body">
              Disclaimer
            </Link>
            <Link to="/sitemap" className="text-muted-foreground text-xs hover:text-primary transition-colors font-body">
              Site Map
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
